module.exports = __webpack_public_path__ + "img/lea-bank-logo.255abc8e.png";